import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input, ElementRef } from '@angular/core';
var SimpleDialogComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function SimpleDialogComponent(element) {
        /**
         * Set our default values
         */
        this.localState = { value: '' };
        this.element = element;
        this.close();
    }
    SimpleDialogComponent.prototype.ngAfterContentInit = function () {
    };
    SimpleDialogComponent.prototype.close = function () {
        this.element.nativeElement.style.display = 'none';
    };
    SimpleDialogComponent.prototype.open = function () {
        this.element.nativeElement.style.display = 'block';
    };
    SimpleDialogComponent.prototype.handleSubmit = function () {
        this.close();
        if (this.onSubmit) {
            this.onSubmit();
        }
    };
    return SimpleDialogComponent;
}());
export { SimpleDialogComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/simple-dialog/simple-dialog.component.ts
// module id = null
// module chunks = 